import app from '../app.first';
import { each, isBoolean } from 'lodash';

app.BaselinePerformers = class extends app.Component {
	onReady() {
		this.table = null;
		this.formInputKey = this.$el.data('formInputKey') || 'baseline_users';
		this.height = 180;
		this.columns = [
			{ data: 'id', type: 'text', width: 1 },
			{ data: 'title', type: 'text', width: 100 },
			{ data: 'initials', type: 'text', width: 140 },
			{ data: 'first_name', type: 'text', width: 140 },
			{ data: 'last_name', type: 'text', width: 140 },
			{ data: 'email', type: 'text', width: 240 }
		];
		this.data = this.$el.data('source') || [];
		this.numPerformers = parseInt(this.$el.data('requiredPerformers') || 5);
		this.columnHeaders = ['id', 'Title', 'Initials', 'First Name', 'Last Name', 'Email Address'];

		if (this.$el.data('checkboxFieldEmail')) {
			this.columns.push({data: this.$el.data('checkboxFieldEmail'), type: 'checkbox', checkedTemplate: 1, uncheckedTemplate: 0});
			this.columnHeaders.push('Send Email');
			this.height = 220;
		}

		if (this.$el.data('checkboxFieldRemove')) {
			this.columns.push({data: this.$el.data('checkboxFieldRemove'), type: 'checkbox', checkedTemplate: 1, uncheckedTemplate: 0});
			this.columnHeaders.push('Remove User');
			this.height = 220;
		}

		this.initFormSubmitHandling();
		this.initTable();
	}

	/**
	 * Hook into parent form submission, add hidden inputs for the table
	 * data in the same format that the Cake ORM can patch the rows
	 * in to the BaselineUser entities.
	 */
	initFormSubmitHandling() {
		let $form = this.$el.parents('form');
		let inputs = [];
		$form.on('submit', e => {
			let failed = false;
			each(inputs, $input => $input.remove());
			inputs = [];

			each(this.data, (baselineUser, index) => {
				each(baselineUser, (value, field) => {
					let requiredFields = ['title', 'initials', 'first_name', 'last_name', 'email'];
					if (requiredFields.indexOf(field) !== -1 && !value) {
						failed = true;
					}

					let name = `${this.formInputKey}[${index}][${field}]`;

					if (isBoolean(value)) {
						value = value ? 1 : 0;
					}

					// to remove &nbsp; from value
					if (typeof value === 'string') {
						let nbsp = new RegExp(String.fromCharCode(160), "g");
						value = value.replace(nbsp, ' ')
					}

					let $hiddenInput = $('<input>', { type: 'hidden', name, value });
					inputs.push($hiddenInput);
				});
			});

			if (failed) {
				e.preventDefault();
				app.showFlash('You need to supply data for all candidates');
				return false;
			}

			$form.append(inputs);
			return true;
		});
	}

	/**
	 * Initialize Handsontable
	 */
	initTable() {
		this.table = new Handsontable(this.el, {
			data: this.data,
			columns: this.columns,
			minRows: this.numPerformers,
			maxRows: this.numPerformers,
			rowHeaders: true,
			height: this.height,
			colHeaders: this.columnHeaders,
			cells: (row, col, prop) => {
				const cellProps = {};
				if (this.data[row] && this.data[row].complete) {
					cellProps.className = 'complete-user'
				}
				return cellProps;
			}
		});
	}
}